<template>
  <b-container fluid class="my-4">
    <b-row>
      <b-col cols="12" md="8" lg="6" class="mx-auto">
        <b-card title="Editar auxiliar">
          <b-form @submit.prevent="submitForm">
            <b-form-group label="Nombre:" label-for="nombre">
              <b-form-input
                id="nombre"
                v-model="auxiliar.nombre"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Apellido:" label-for="apellido">
              <b-form-input
                id="apellido"
                v-model="auxiliar.apellido"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Fecha de Inicio:" label-for="fechainicio">
              <b-form-input
                id="fechainicio"
                v-model="auxiliar.fechainicio"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Fecha de Fin:" label-for="fechafin">
              <b-form-input
                id="fechafin"
                v-model="auxiliar.fechafin"
                type="text"
                @input="saveToLocalStorage"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Correo Electronico:" label-for="correo">
              <b-form-input
                id="correo"
                v-model="auxiliar.correo"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Celular" label-for="celular">
              <b-form-input
                id="celular"
                v-model="auxiliar.celular"
                type="text"
                @input="saveToLocalStorage"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Identificacion" label-for="identificacion">
              <b-form-input
                id="identificacion"
                placeholder="0999999999"
                name="identificacion"
               
                type="text"
                :maxlength=10
                v-model="auxiliar.identificacion"
                
                
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group label-for="tipoauxiliar">
           
              <label>Tipo de Auxiliar: <span class="text-danger">*</span></label>
           
              <v-select
                id="auxiliar"
                v-model="auxiliar.tipoauxiliar"
                :options="tipoAuxiliarOpts"
                label="text"
                class="d-inline-block w-100"
                required
              />
                
            </b-form-group>
       
            <b-form-group label="Estado:" label-for="estado-switch">
              <b-form-checkbox
                id="estado-switch"
                v-model="auxiliar.estado"
                value="1"
                unchecked-value="0"
                switch
              />
            </b-form-group>
            <b-button 
              type="submit" 
              variant="primary" 
              @click="clearLocalStorage"
            >Actualizar auxiliar</b-button>

            <b-button 
              @click="salir()" 
              class="float-right" 
              variant="danger"
            >
              Salir
            </b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from "vue-select";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";


export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    vSelect,
  },
 
  data() {
    return {
      identificacionrepetida: false,
      idenOriginal:null,
      
      tipoAuxiliarOpts : [],
      identificaciones : [],
      auxiliar: {
        id: "",
        nombre: "",
        apellido: "",
        fechainicio: "",
        fechafin: "",
        correo: "",
        celular: "",
        identificacion: "",
        especialidad: "",
        tipoIdent: "",
        sexo: "",
        fechaNacimiento: "",
        urlIdentificacion: " ",
        estadoCivil: "",
        nacionalidad: "",
        nivelEducacion: "",
        profesion: "",
        pueKichwa: " ",
        tipoBono: "",
        nacioEtni: "",
        cprincipal: "",
        csecundaria: "",
        referenciasect: "",
        idbarrio: "",
        esDiscapacitado: 0,
        urlCarnet: "",
        tipoauxiliar: null,
        estado: 0,

        doctor: null,
        idPersona: 0,
      },

      opsEspecialidad: [],
      opsDoctores: [],
    };
  },
  created() {
    const tokenauxiliar = this.$route.params.token;
    this.fetchPersonas();
    this.fetchEspecilidades();
  
    this.fetchAuxiliar(tokenauxiliar);
    this.comprobarPermisos();
  },
  methods: {
    async fetchPersonas(search = '') {
    const query = `
        query MyQuery($search: String) {
            allPersona(search: $search) {
                
                
                    correo
                    telefono
                    identificacion
                    primerApellido
                    primerNombre
                    primerApellido
                    id
                
            }
        }`;

    try {
        const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
                search,
             
            }
        });

        
        console.log(response.data);

        let personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
            identificaciones.push(persona.identificacion);
        });

        this.identificaciones = identificaciones

        
    } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
    }
},
   
    async fetchEspecilidades() {
      const query = `
        query MyQuery {
  allTipoEspecialidades {
    descripcion
    id
  }
}
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        console.log("response", response)
        this.tipoAuxiliarOpts = response.data.data.allTipoEspecialidades.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('editar_auxiliar') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    salir() {
      this.$router.push({ name: "consultar_auxiliar" });
    },
    saveToLocalStorage() {
      localStorage.setItem("auxiliar", JSON.stringify(this.auxiliar));
    },
 
    async fetchEspecilidades() {
      const query = `
                  query MyQuery {
              allEspecialidad {
                descripcion
                id
              }
            }
                `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });

        this.opsEspecialidad = response.data.data.allEspecialidad.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,
          })
        );
      } catch (error) {
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
 
    //Intento de envio de dos consultas en graphql para el envio de datos. Para actualizar auxiliar medico y para actualizar persona
    async submitForm() {
      
      if (this.identificacionrepetida){
        if(this.idenOriginal !== this.auxiliar.identificacion) {
        await this.$swal.fire({
          icon : "error",
          title : "Cedula repetida",
          text : "Ingrese otra cedula, esa ya existe en la base de datos!"
        })
        return
      }
      }
      try {
        let idP = this.auxiliar.idPersona;
        let idPersona = parseInt(idP);
        // Definir las variables

        const variablesConsulta1 = {
          id: this.auxiliar.id,
          idPersona: idPersona,
          tipoAuxiliar: this.auxiliar.tipoauxiliar.value,
          
          fechafin: this.auxiliar.fechafin,
          fechainicio: this.auxiliar.fechainicio,
        };

        const variablesConsulta2 = {
          nombres: this.auxiliar.nombre,
          apellidos: this.auxiliar.apellido,

          identificacion: this.auxiliar.identificacion,
          telefono: this.auxiliar.celular,
          email: this.auxiliar.correo,
          esDiscapacitado: 0,
          idPersona: idP,

          tipoIdent: this.auxiliar.tipoIdent.toString() || "", 
          sexo: this.auxiliar.sexo.toString() || "",
          fechaNacimiento: this.auxiliar.fechaNacimiento || "",
          urlIdentificacion: this.auxiliar.urlIdentificacion || "",
          estadoCivil: this.auxiliar.estadoCivil.toString() || "",
          tipoBono : this.auxiliar.tipoBono || "",

          nacionalidad: this.auxiliar.nacionalidad || "",
          nacioEtni: "",
          nivelEducacion: this.auxiliar.nivelEducacion || "",
          profesion: this.auxiliar.profesion || "",
          pueKichwa: "",
          cprincipal: this.auxiliar.cprincipal || "",
          csecundaria: this.auxiliar.csecundaria || "",
          referenciasect: "",
          idbarrio: this.auxiliar.idbarrio || "",
          
          urlCarnet: this.auxiliar.urlCarnet || "",
        };

        // Definir las consultas GraphQL
        const query1 = `
        mutation ActualizarAuxiliarMedico($id: ID!, $idPersona: Int!, $tipoAuxiliar: ID! $fechafin: String!, $fechainicio: String!) {
            ActualizarAuxiliarMedico(
              auxiliarMedicoData: {idPersona: $idPersona, tipoAuxiliar : $tipoAuxiliar, fechafin: $fechafin, fechainicio: $fechainicio}
              id: $id
            ) {
              message
              status
              auxiliar {
                fechafin
                fechainicio
              }
            }
          }
          
        `;

        const query2 = `
        mutation actualizarPersonaMut (
          $nombres: String!,
          $apellidos: String!,
          $tipoIdent: String!,
          $identificacion: String!,
          $sexo: String!,
          $fechaNacimiento: String!,
          $urlIdentificacion: String!,
          $estadoCivil:String!,
          $telefono:String!,
          $nacionalidad:String,
          $nivelEducacion:String,
          $email:String,
          $profesion:String,
          $pueKichwa:String,
          $tipoBono:String,
          $nacioEtni:String,
          $cprincipal: String!,
          $csecundaria: String,
          $referenciasect: String,
          $idbarrio: String!,
          $idPersona: String!,
          $esDiscapacitado: Int,
          $urlCarnet: String,
        ){
          actualizarPersona(
            nombres:$nombres
            apellidos:$apellidos
            tipoIdent:$tipoIdent
            identificacion:$identificacion
            estadoCivil:$estadoCivil
            urlIdentificacion:$urlIdentificacion
            sexo:$sexo	
            telefono:$telefono
            fechaNacimiento:$fechaNacimiento
            nacionalidad:$nacionalidad
            nivelEducacion:$nivelEducacion
            email: $email
            profesion:$profesion
            pueKichwa:$pueKichwa
            tipoBono:$tipoBono
            nacioEtni:$nacioEtni
            cprincipal:$cprincipal
            csecundaria:$csecundaria
            referenciasect:$referenciasect
            idbarrio:$idbarrio
            idPersona:$idPersona
            esDiscapacitado: $esDiscapacitado
            urlCarnet: $urlCarnet
          ){
            persona {
              token,id, primerNombre, primerApellido, identificacion
            }
            status,
            message
          }
        }
        `;

        // Enviar la primera consulta con variables
        const response1 = await axios.post(rutas.axios + "api", {
          query: query1,
          variables: variablesConsulta1,
        });

        // Enviar la segunda consulta con variables
        const response2 = await axios.post(rutas.axios + "api", {
          query: query2,
          variables: variablesConsulta2,
        });

        // Manejar las respuestas de la API aquí
        if (response1.data.data.ActualizarAuxiliarMedico.status === "success" && response2.data.data.actualizarPersona.status === "success") {
      await this.$swal({
        icon: "success",
        title: "Éxito",
        text: "Los campos se actualizaron correctamente.",
      }).then(() => {
        this.$router.push({ name: "consultar_auxiliar" });
      });
    } else {
      throw new Error("Hubo un problema al actualizar el auxiliar o la persona.");
    }
  } catch (error) {
    await this.$swal({
      icon: "error",
      title: "Error",
      text: error.message || "Hubo un problema al actualizar el auxiliar o la persona.",
    });
  }
      
     
    },

    

    async fetchAuxiliar(tokenauxiliar) {
      // Verificar si los datos del API ya se han cargado previamente
      
        let storedAuxiliar = localStorage.getItem("auxiliar");
        if (storedAuxiliar) {
          let auxiliarGuardado = JSON.parse(storedAuxiliar);
                 
          if (tokenauxiliar === auxiliarGuardado.token) { 
          this.auxiliar = auxiliarGuardado;
          this.idenOriginal = this.auxiliar.identificacion
          return; // Salir del método si los datos ya se han cargado desde el local storage
        }
      }

      const query = `
              query obtenerAuxiliar($tokenauxiliar : String!) {
          auxiliar(tokenauxiliar : $tokenauxiliar) {
            message
            status
            auxiliar {
              token
              idPersona {
                id
                primerNombre
                primerApellido
                segundoNombre
                segundoApellido
                tipoIdentificacion
                estadoCivil
                urlIdentificacion
                sexo
                esDiscapacitado
                urlCarnet
                fechaNacimiento
                nacionalidad {
                  id
                  descripcion
                }
                nivelEducacion {
                  id
                  descripcion
                }
                correo
                ocupacion {
                  id
                  descripcion
                }
                pueblokichwa {
                  descripcion
                }
                tipoBono {descripcion}
                nacionalidadEtnia {descripcion}
                residencia {
                  callePrincipal
                  calleSecundaria
                  referenciaSector
                  idbarrio {
                    id
                  }
                }
                
                identificacion
                telefono 
                
              }
             
              tipoauxiliar {
                id
                descripcion
              }
              fechafin
              fechainicio
              estado
              id
              
              
            }
          }
        }
      `;
      const variables = {
        tokenauxiliar: tokenauxiliar,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });
        if (response.data.data.auxiliar.status === "Success") {
          
          if (response.data.data.auxiliar.auxiliar) {
            const auxiliarData = response.data.data.auxiliar.auxiliar;
            
            const nivele = auxiliarData.idPersona.nivelEducacion? auxiliarData.idPersona.nivelEducacion.id : ''
            const nac = auxiliarData.idPersona.nacionalidad ? auxiliarData.idPersona.nacionalidad.id : ''
            // this.idPersona = auxiliarData.idPersona.id;
            this.idenOriginal = auxiliarData.idPersona.identificacion
            
            this.auxiliar = {
              id: auxiliarData.id,
              // token: auxiliarData.token,
              //para persona
              nombre: auxiliarData.idPersona.primerNombre,
              apellido: auxiliarData.idPersona.primerApellido,
              correo: auxiliarData.idPersona.correo,
              celular: auxiliarData.idPersona.telefono || "",
              identificacion: auxiliarData.idPersona.identificacion,
              tipoIdent: auxiliarData.idPersona.tipoIdentificacion,
              sexo: auxiliarData.idPersona.sexo,
              fechaNacimiento: auxiliarData.idPersona.fechaNacimiento,
              urlIdentificacion: auxiliarData.idPersona.urlIdentificacion,
              estadoCivil: auxiliarData.idPersona.estadoCivil,
              nacionalidad: nac,
              nivelEducacion: nivele,
              profesion: auxiliarData.idPersona.ocupacion ? auxiliarData.idPersona.ocupacion.id : '',
              //pueKichwa: auxiliarData.idPersona.pueKichwa.descripcion,
              cprincipal: auxiliarData.idPersona.residencia.callePrincipal,
              csecundaria: auxiliarData.idPersona.residencia.calleSecundaria,
              referenciasect: auxiliarData.idPersona.residencia.referenciaSect,
              idbarrio: auxiliarData.idPersona.residencia.idbarrio ? auxiliarData.idPersona.residencia.idbarrio.id : '',
              tipoBono: auxiliarData.idPersona.tipoBono,
              
              urlCarnet: auxiliarData.idPersona.urlCarnet,

              idPersona: auxiliarData.idPersona.id,

              //para auxiliar
              tipoauxiliar:{
                text: auxiliarData.tipoauxiliar.descripcion,
                value: auxiliarData.tipoauxiliar.id},

              

              estado: auxiliarData.estado,
              fechainicio: auxiliarData.fechainicio,
              fechafin: auxiliarData.fechafin,
            };
            
            // Guardar los datos en el local storage
            localStorage.setItem("auxiliar", JSON.stringify(this.auxiliar));
          }
        } else {
          console.error("Error al obtener la auxiliar:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },

    clearLocalStorage() {
      // Eliminar los datos del local storage
      localStorage.removeItem("auxiliar");
    },
  },
  watch: {
    'auxiliar.identificacion'(newVal) {
      if (newVal.length >9) {
        if(this.identificaciones.includes(newVal) && newVal !== this.idenOriginal){
         
          this.$toast.error("La identificacion ya fue ingresada anteriormente!");
          this.identificacionrepetida = true
        }else{
        this.$toast.success("Identificacion correcta");
        this.identificacionrepetida = false
      }
        
      }
    },
  }
};
</script>

<style>
/* Estilos personalizados si son necesarios */
</style>
